import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';

export interface FormFieldOption {
  value: string;
  label: string;
}

export interface FormField {
  key: string;
  label: string;
  placeholder?: string;
  value?: string;
  type?: 'text' | 'number' | 'email' | 'password' | 'select';
  required?: boolean;
  maxLength?: number;
  options?: FormFieldOption[];
}

export interface DialogInputData {
  title: string;
  fields: FormField[];
}

@Component({
  selector: 'app-dialog-input',
  templateUrl: './dialog-input.component.html',
  styleUrls: ['./dialog-input.component.scss']
})
export class DialogInputComponent {
  formValues: { [key: string]: string } = {};

  constructor(
    public dialogRef: MatDialogRef<DialogInputComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogInputData,
    private snackbarService: SnackbarService,
    private translate: TranslateService
  ) {
    this.data.fields.forEach((field) => {
      this.formValues[field.key] = field.value || '';
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onValidate(): void {
    const requiredFields = this.data.fields.filter((field) => field.required);
    const missingFields = requiredFields.filter((field) => !this.formValues[field.key] || this.formValues[field.key].trim() === '');

    if (missingFields.length > 0) {
      this.snackbarService.open(this.translate.instant('error_fill_required_fields'));
      return;
    }

    if (this.data.fields.length === 1) {
      this.dialogRef.close(this.formValues[this.data.fields[0].key]);
    } else {
      this.dialogRef.close(this.formValues);
    }
  }

  isFormValid(): boolean {
    const requiredFields = this.data.fields.filter((field) => field.required);
    return requiredFields.every((field) => this.formValues[field.key] && this.formValues[field.key].trim() !== '');
  }
}
